import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchBlog } from "../../features/blog/blogSlice";
import {
  fetchLikeAndSaved,
  updateLikes,
  updateSaved,
} from "../../features/likeAndSaved/likeAndSavedSlice";

export default function BlogPost() {
  const { blogId } = useParams();
  const { title, description, image, tags } = useSelector(
    (state) => state.blog.blog
  );
  const { isLoading, error } = useSelector((state) => state.blog);
  const { likes, isSaved } = useSelector((state) => state.likeAndSaved);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchBlog(blogId));
    dispatch(fetchLikeAndSaved(blogId));
  }, [dispatch, blogId]);

  const handleLike = () => {
    dispatch(updateLikes({ blogId, likes }));
  };
  const handleSaved = () => {
    dispatch(updateSaved({ blogId, isSaved }));
  };
  return (
    <>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        error
      ) : (
        <main className="post">
          <img
            src={image}
            alt="githum"
            className="w-full rounded-md"
            id="lws-megaThumb"
          />
          <div>
            <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
              {title}
            </h1>
            <div className="tags" id="lws-singleTags">
              {tags?.map((tag, i) => {
                // if its the last tag then dont' add comma
                if (tags.length === i + 1) {
                  return <span key={i}>#{tag} </span>;
                } else {
                  return <span key={i}>#{tag + ","} </span>;
                }
              })}
            </div>
            <div className="btn-group">
              <button
                className="like-btn"
                id="lws-singleLinks"
                onClick={handleLike}
              >
                <i className="fa-regular fa-thumbs-up"></i> {likes}
              </button>
              <button
                onClick={handleSaved}
                className={`save-btn ${isSaved && "active"}`}
                id="lws-singleSavedBtn"
              >
                <i className="fa-regular fa-bookmark"></i>{" "}
                {isSaved ? "Saved" : "Save"}
              </button>
            </div>
            <div className="mt-6">
              <p>{description}</p>
            </div>
          </div>
        </main>
      )}
    </>
  );
}
